export const appealTitle = {
    1: '号码标记申诉',
    2: '号码占用申诉'
};
export const appealSubTitle = {
    1: '号码被标记为骚扰、推销等类型，可申诉取消',
    2: '个人、企业、政府被占用，可申诉取消'
};
export const appealBannerClass = {
    1: 'appeal-banner',
    2: 'occupy-banner'
};
export const appealTypeEventTracking = {
    1: 'person', // 个人
    2: 'company', // 企业
    3: 'government' // 政府
};
export const rePhone = /^1[3456789]\d{9}$/;
export const getPhoneName = data => {
    if (!data) {
        return '';
    }
    const dataInfo = data?.list[0];
    let phoneName = '';
    switch (data.mode) {
        case 'customer':
            phoneName = dataInfo.key || dataInfo.title;
            break;
        case 'reports':
            phoneName = dataInfo.tag;
            break;
        case 'poi':
            phoneName = dataInfo.name;
            break;
    }
    return phoneName;
};

export const initialStateErr = {
    // 个人
    phoneErr: '',
    certErr: '',
    emailErr: '',
    emailCodeErr: '',
    phoneCodeErr: '',
    // 企业
    companyQualifyErr: '',
    companyNameErr: '',
    companyAddressErr: '',
    // 政府
    socialErr: '',
    nameGovErr: ''
};
